const ValeurItem = ({valeur, valeurClass = "", text, textClass = ""}) => {
    return <li className={textClass}><span className={valeurClass}>{valeur}</span>: {text}</li>
}

export default ValeurItem;